export default __webpack_public_path__ + "static/background-42c4acbe62f3d4aa1a8b462618b33734.png";